exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "delegated-card-request-counter .delegated-card-request-counter-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;text-align:center;color:#0072c9}delegated-card-request-counter .delegated-card-request-counter-container .counter-number{font-size:28px;height:30px}delegated-card-request-counter .delegated-card-request-counter-container .counter-label{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequestCounter/delegatedCardRequestCounter.scss
// module id = 1723
// module chunks = 0